import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\CreateDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CreateDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
const CreateDossierEnaosController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierEnaosController.url(args, options),
    method: 'post',
})

CreateDossierEnaosController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/enaos',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\CreateDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CreateDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
CreateDossierEnaosController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return CreateDossierEnaosController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\CreateDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/CreateDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
CreateDossierEnaosController.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: CreateDossierEnaosController.url(args, options),
    method: 'post',
})

export default CreateDossierEnaosController